<template>
  <v-container fluid>
    <v-flex xs12 sm6 offset-sm3 mt-6 class="transparent-bg">
      <h1 class="text-center mb-4 font-weight-light">
        Niestety nie znaleziono podanej strony
      </h1>
      <div class="d-flex justify-center w-full flex-wrap">
        <a href="https://dagajoga.pl/"
          ><button
            type="submit"
            class="primary-button mx-2"
            @click="moveToDagajogaPage"
          >
            Strona główna Dagajoga.pl
          </button></a
        >
        <button type="submit" class="primary-button mx-2" @click="moveToCourses">
          Kursy jogi online
        </button>
      </div>
    </v-flex>
  </v-container>
</template>

<script>
import router from "../router";
export default {
  name: "NotFound",

  data() {
    return {};
  },

  created() {},
  methods: {
    moveToDagajogaPage() {
      router.resolve("https://dagajoga.pl/");
    },
    moveToCourses() {
      router.push({ name: "Courses" });
    },
  },
};
</script>

<style scoped>
.transparent-bg {
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px;
  position: relative;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
  margin: auto;
}
.btn-gradient {
  padding: 8px 32px;
  border-radius: 30px;
  margin-top: 1rem;
  font-size: 1rem;
  font-weight: 500;
  min-width: 280px;
}
</style>
